/**
 * @generated SignedSource<<8bea9289e5dd34ddaba3142dabc81725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddContactDialog_customerAccount$data = {
  readonly id: string;
  readonly " $fragmentType": "AddContactDialog_customerAccount";
};
export type AddContactDialog_customerAccount$key = {
  readonly " $data"?: AddContactDialog_customerAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddContactDialog_customerAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddContactDialog_customerAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "CustomerAccount",
  "abstractKey": null
};

(node as any).hash = "97c4ce18bdc6c580904e907de32b5a44";

export default node;
